<script>
    import FriendRow from './FriendRow.svelte';
    import { user } from '../stores';
    import { db } from '../firebase';

    export let requests;

    $: console.log('requests in IncomingFriendRequests:', requests);
</script>

<h4>Friend requests received</h4>
{#each requests as request, i}
	<FriendRow
		friend={request}
		type="incoming"
        onAccept={(event) => {
            console.log(event);
            const friendRef = $user.ref.collection('friends').doc(request.uid);
            friendRef.get()
                .then(docRef => {
                    if (docRef.exists) {
                        console.warn('User already in our friends list, this shouldn\'t happen');
                    } else {
                        return friendRef.set({
                            friendId: docRef.id,
                            realNameShared: false
                        });
                    }
                })
                .then(() => console.log('Friend request accepted'))
                .catch(e => console.log(`Error accepting friend request: ${e}`));
        }}
	/>
{:else}
    <p>No friend requests received!</p>
{/each}